class footerAccordion extends HTMLElement {
  connectedCallback() {
    if (this.ready || this.classList.contains('admin-panel--no-js')) return;
    this.ready = true;
    this.boxes = [...this.querySelectorAll('.footer__accordion__heading')];
    this.media = window.matchMedia('(max-width: 576px)');
    this.boxes.forEach((heading, index) => {
      const content = heading.nextElementSibling;
      if (!content) return;
      content.id ||= `footer-content-${this.closest('[id]')?.id || 'main'}-${index}`;
      heading.setAttribute('aria-controls', content.id);
      heading.addEventListener('click', () => this.toggle(heading));
      heading.addEventListener('keydown', event => {
        if (this.media.matches && ['Enter', ' '].includes(event.key)) {
          event.preventDefault();
          this.toggle(heading);
        }
      });
    });
    this.sync = () => this.boxes.forEach(heading => {
      if (this.media.matches) {
        heading.setAttribute('role', 'button');
        heading.tabIndex = 0;
        heading.setAttribute('aria-expanded', String(heading.hasAttribute('open')));
      } else {
        heading.removeAttribute('role');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-expanded');
      }
    });
    this.media.addEventListener('change', this.sync);
    this.setAttribute('data-ready', '');
    this.sync();
  }
  toggle(heading) {
    if (!this.media.matches) return;
    const shouldOpen = !heading.hasAttribute('open');
    this.boxes.forEach(item => {
      const open = item === heading && shouldOpen;
      item.toggleAttribute('open', open);
      item.classList.toggle('footer__accordion-opening', open);
      item.setAttribute('aria-expanded', String(open));
    });
  }
  disconnectedCallback() {
    this.media?.removeEventListener('change', this.sync);
  }
}
if (!customElements.get('footer-accordion')) customElements.define('footer-accordion', footerAccordion);
